<template>
    <div class="wrapper tab-not-eligible">
        <header>
            <span class="new-headline-lg text-centered">Vitadio ist nur für Menschen mit Typ&#8209;2&#8209;Diabetes.</span>
        </header>

        <div class="onboarding-card">
            <div class="onboarding-card-body">
                <strong class="new-text-xl">Unsicher, ob Sie Typ&#8209;2&#8209;Diabetes haben?</strong>

                <p class="new-text-lg text-color-default">Vereinbaren Sie eine kostenlose Videosprechstunde mit einer Ärzt:in bei GoMedicus. Sie erhalten eine persönliche medizinische Beratung und können Fragen zu Diabetes besprechen. Bei entsprechender Diagnose kann Ihnen Vitadio verschrieben werden.</p>

                <div class="btn-group">
                    <v-button :href="goMedicusUrl" target="_blank" label="Termin buchen"></v-button>
                    <v-button href="/" label="Zur Startseite" variant="secondary"></v-button>
                </div>
            </div>

            <figure class="onboarding-card-image">
                <img src="imgs/web/img_quiz_form.svg" alt="">
            </figure>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            goMedicusUrl: 'https://gomedicus.de/booking-referral?ref=Z29tLXJsOmU1NzY3YjlhLTg4NzQtNDdkNC1hZGMyLTc5N2E5ODhlYWIzZA'
        }
    }
}
</script>
